import { useParams } from "react-router";
import { DaPasswordSaved } from "../../components/DaPasswordSaved/DaPasswordSaved";

function DaPasswordSavedPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaPasswordSaved /> : null}
    </div>
  );
}

export default DaPasswordSavedPage;
